import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService, DownloadFormat, HttpMethod } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { Tag, TagTypes } from '../ui/tags/tags.component';
var ManageCoursesComponent = /** @class */ (function () {
    function ManageCoursesComponent(appService, dialogService, downloadService, errorService, fb, mediaChange, splashService, userService) {
        this.appService = appService;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['Prefix', 'Code', 'Colleges', 'Actions'];
        this.FilterText = "";
        this.FilteredCourses = [];
        this.TagTypes = TagTypes;
    }
    Object.defineProperty(ManageCoursesComponent.prototype, "CollegesCtrl", {
        get: function () {
            return this.CourseEntryForm && this.CourseEntryForm.get('Colleges');
        },
        enumerable: true,
        configurable: true
    });
    ManageCoursesComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AdminCollege = null;
        self.Colleges = null;
        self.CollegeNames = [];
        self.FilterText = "";
        self.NoData = false;
        self.PartialViewReady = false;
        self.ShowingCourseEntryPanel = false;
        self.SmallDisplay = false;
        self.Courses = null;
        self.CoursesData = new DataTableSource([], self.paginator, self.sorter, self.SortCourses.bind(self), [
            'Prefix',
            'Code',
            'Colleges',
        ]);
        self.TagOptions = null;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Setup the form group
        self.CourseEntryForm = self.fb.group({
            Prefix: ['', Validators.required],
            Code: ['', Validators.required],
            Colleges: [[], [Validators.min(1)]],
            EligibleCourseID: [null],
        });
        // fromEvent(self.filter.nativeElement, 'keyup')
        //     .pipe(
        //         takeUntil(self._subrelease),
        //         debounceTime(150),
        //         distinctUntilChanged()
        //     )
        //     .subscribe(() => {
        //         if (!self.CoursesData) {
        //             return;
        //         }
        //         self.CoursesData.filter = this.filter.nativeElement.value;
        //     });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var coursesObs = self.appService.GetAllEligibleCourses(self.User.AuthToken);
            var collegeObs = self.appService.GetAllColleges(self.User.AuthToken);
            var adminCollegeObs = self.appService.SelectedAdminCollegeIDSubject;
            combineLatest(coursesObs, collegeObs, adminCollegeObs, function (courses, colleges, adminCollegeID) {
                return {
                    EligibleCourses: courses,
                    AdminCollegeID: adminCollegeID,
                    Colleges: colleges,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.Colleges = packet.Colleges;
                self.AdminCollegeID = packet.AdminCollegeID;
                self.Courses = packet.EligibleCourses;
                self.AdminCollege = null;
                if (self.AdminCollegeID != null && self.Colleges) {
                    self.AdminCollege = self.Colleges.find(function (item) {
                        return item.CollegeID === self.AdminCollegeID;
                    });
                }
                if (!self.Courses || !self.Courses.length) {
                    // self.NoData = true;
                    // Put in a fake record to trip the display message
                    self.CoursesData.Update([{}]);
                }
                else {
                    // self.NoData = false;
                    self.CoursesData.Update(self.Courses);
                }
                self.TagOptions = self.Colleges.map(function (c) { return new Tag(c.CollegeAbbreviation, c.CollegeID, c.Active); });
                self.CollegeAbbreviations = self.Colleges.map(function (c) { return c.CollegeAbbreviation; });
                self.CollegeNames = self.Colleges.map(function (c) { return c.CollegeName; });
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
                // Ready for component use.
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageCoursesComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add Course Cancel Handler Method
    ManageCoursesComponent.prototype.AddCourseCancelHandler = function () {
        var self = this;
        // Null out the form, then close the panel.
        self.CourseEntryForm.reset();
        self.ShowingCourseEntryPanel = false;
    };
    // #endregion
    // #region Add Eligible Course Method
    ManageCoursesComponent.prototype.AddEligibleCourse = function (colleges) {
        var self = this;
        // Patch value from child component before continueing
        if (self.CourseEntryForm.get('Colleges')) {
            self.CourseEntryForm.get('Colleges').patchValue(colleges.map(function (x) { return x.id; }));
        }
        var form = self.CourseEntryForm.getRawValue();
        if (!form) {
            return;
        }
        var nPrefix = form.Prefix.toUpperCase();
        var nCode = form.Code.toUpperCase();
        var nColleges = form.Colleges;
        var collegeNames = self.Colleges.filter(function (x) { return nColleges.includes(x.CollegeID); }).map(function (x) { return x.CollegeName; }).join(', ');
        console.log({ colleges: colleges, form: form, collegeNames: collegeNames });
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You are about to add the following new eligible course to DELTA:<br /><br />\n            <strong>Prefix: </strong>" + nPrefix + "<br />\n            <strong>Code: </strong>" + nCode + "<br /><br />\n            <strong>Colleges: </strong>" + collegeNames + "<br /><br />\n            Once added, this course will become searchable and usable immediately within DELTA, assuming this " +
                "course is provided by a specific college or university. Are you sure you wish to continue?",
            OKText: 'Yes - Add Course',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to add the course to the system.
                self.splashService
                    .DisplaySplash({ TitleText: 'Please wait', MessageText: 'Adding course...' })
                    .pipe(takeUntil(self._subrelease))
                    .subscribe(function () {
                    self.appService.AddEligibleCourse(self.User.AuthToken, nPrefix, nCode, nColleges).subscribe(function (courses) {
                        // Toast the success
                        self.splashService.CloseSplash();
                        self.splashService.SnackbarSuccess('New eligible course added successfully.');
                        // Update the list of eligible courses
                        self.UpdateCoursesDisplay(courses);
                        // Reset the course form
                        self.CourseEntryForm.reset();
                        // Hide the panel
                        self.ShowingCourseEntryPanel = false;
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Add Eligible Course College Method
    ManageCoursesComponent.prototype.AddEligibleCourseCollege = function (collegeID, eligibleCourseID) {
        var self = this;
        if (!eligibleCourseID) {
            return;
        }
        self.appService.AddEligibleCourseCollege(self.User.AuthToken, eligibleCourseID, collegeID).subscribe(function (res) { }, function (error) { return self.errorService.HandleServiceError(error); });
    };
    // #endregion
    // #region Download Eligible Courses PDF Method
    ManageCoursesComponent.prototype.DownloadEligibleCoursesPDF = function () {
        var self = this;
        // Set splash
        self.splashService
            .DisplaySplash({ TitleText: 'Please wait', MessageText: 'Downloading Eligible Courses PDF...' })
            .pipe(takeUntil(self._subrelease))
            .subscribe(function () {
            self.downloadService
                .RetrieveDownload(HttpMethod.GET, "Api/Services/PDF/PDFDownloadEligibleCoursesList", {
                AuthToken: self.User.AuthToken,
                Attachment: true,
            }, DownloadFormat.PDF)
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (success) {
                // Drop the splash?
                self.splashService.CloseSplash();
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #endregion
    // #region Remove Eligible Course Method
    ManageCoursesComponent.prototype.RemoveEligibleCourse = function (ecor) {
        var self = this;
        if (!ecor) {
            return;
        }
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: "You have chosen to remove the following eligible course from the system:<br /><br />\n            <strong>Prefix: </strong>" + ecor.Prefix + "<br />\n            <strong>Code: </strong>" + ecor.Code + "<br /><br />\n            Once removed, this course will no longer be recognized as an eligible dual enrollment course. This " +
                "will prevent students and counselors from being able to search for this course and adding it to " +
                "course requests. This will <em>not</em> remove this course from any current or previous course " +
                "request lists, however. Are you sure you wish to continue?",
            OKText: 'Yes - Remove Course',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to remove this term window from the college.
                self.appService.RemoveEligibleCourse(self.User.AuthToken, ecor.EligibleCourseID).subscribe(function (courses) {
                    // Toast the success
                    self.splashService.CloseSplash();
                    self.splashService.SnackbarSuccess('Eligible course was removed successfully.');
                    // Update the list of eligible courses
                    self.UpdateCoursesDisplay(courses);
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Remove Eligible Course College Method
    ManageCoursesComponent.prototype.RemoveEligibleCourseCollege = function (collegeID, eligibleCourseID) {
        var self = this;
        if (!eligibleCourseID) {
            return;
        }
        self.appService.RemoveEligibleCourseCollege(this.User.AuthToken, eligibleCourseID, collegeID).subscribe(function (res) { }, function (error) { return self.errorService.HandleServiceError(error); });
    };
    // #endregion
    // #region Show Course Entry Editor Panel Method
    ManageCoursesComponent.prototype.ShowCourseEntryEditorPanel = function (ecor) {
        var self = this;
        // Set up the formgroup to prepare for editing. If we were provided a course, use those values to prefill the formgroup.
        var newform;
        if (ecor) {
            newform = {
                Prefix: ecor.Prefix,
                Code: ecor.Code,
                EligibleCourseID: ecor.EligibleCourseID,
            };
        }
        else {
            // Clear the form
            newform = {
                Prefix: '',
                Code: '',
                EligibleCourseID: null,
            };
        }
        self.CourseEntryForm.patchValue(newform);
        self.CourseEntryForm.updateValueAndValidity({ emitEvent: false });
        self.ShowingCourseEntryPanel = true;
    };
    // #endregion
    // #region Sort Courses Method
    ManageCoursesComponent.prototype.SortCourses = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'Prefix':
                _a = [First.Prefix.toUpperCase(), Second.Prefix.toUpperCase()], PropA = _a[0], PropB = _a[1];
                break;
            case 'Code':
                _b = [First.Code.toUpperCase(), Second.Code.toUpperCase()], PropA = _b[0], PropB = _b[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b;
    };
    // #endregion
    // #region Update Courses Display Method
    ManageCoursesComponent.prototype.UpdateCoursesDisplay = function (courses) {
        var self = this;
        self.Courses = courses;
        if (!self.Courses || !self.Courses.length) {
            // self.NoData = true;
            // Put in a fake record to trip the display message
            self.CoursesData.Update([{}]);
        }
        else {
            // self.NoData = false;
            self.CoursesData.Update(self.Courses);
        }
    };
    // #endregion
    // #region Update Filter
    ManageCoursesComponent.prototype.UpdateFilter = function () {
        var self = this;
        var ltext = self.FilterText.toLocaleLowerCase();
        var collegeAbbreviations = self.CollegeAbbreviations;
        var collegeName = self.CollegeNames;
        self.FilteredCourses = (self.Courses || []).filter(function (t) {
            return ((!ltext ||
                !!(t.Colleges || []).some(function (x) {
                    return (collegeAbbreviations.includes(x.CollegeAbbreviation) && x.CollegeAbbreviation.toLocaleLowerCase().indexOf(ltext) >= 0) ||
                        (collegeName.includes(x.CollegeName) && x.CollegeName.toLocaleLowerCase().indexOf(ltext) >= 0);
                }) ||
                t.Code.toLocaleLowerCase().indexOf(ltext) >= 0 ||
                t.Prefix.toLocaleLowerCase().indexOf(ltext) >= 0));
        });
        self.CoursesData.dataChange.next(self.FilteredCourses);
    };
    return ManageCoursesComponent;
}());
export { ManageCoursesComponent };



// WEBPACK FOOTER //
// ./src/app/managecourses/managecourses.component.ts.pre-build-optimizer.js